import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=e7406b78&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7406b78')) {
      api.createRecord('e7406b78', component.options)
    } else {
      api.reload('e7406b78', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=e7406b78&", function () {
      api.rerender('e7406b78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27LnDkt6wb5zl/JS/comp/IncreaseNumber.vue"
export default component.exports